/**
 * CloseCircleIcon/index.js
 * desc: inline close icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CloseCircleIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="inline-close icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.closeCircle.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M0 12C0 5.364 5.364 0 12 0s12 5.364 12 12-5.364 12-12 12S0 18.636 0 12zm15.59 5L17 15.59 13.41 12 17 8.41 15.59 7 12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17z" /></svg>
    </IconButton>
);


export default CloseCircleIcon;
